// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.switch_container__p1G07 {
  display: flex;
  flex-direction: column;
  justify-content: end;
  width: 100%;
  border-radius: 6px;
  margin: 0 30px 10px 30px;
  position: relative;
  align-items: center;
}

.switch_switch__JeJO9 {
  width: 31px;
  height: 71px;
  position: relative;
  display: inline-block;
  padding: 8px;
  margin-bottom: 5px;
  border-radius: 200px;
  background-color: #49546e;
  cursor: pointer;
  transition: background-color 0.3s ease, opacity 0.3s ease;
  -webkit-user-select: none;
          user-select: none;
}

.switch_toggle__75E7X {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 16px;
  top: 3px;
  width: 25px;
  height: 25px;
  transform: translateX(-50%);
  background-color: #88d36e;
  border-radius: 50%;
  transition: transform 0.3s ease, background-color 0.3s ease;
  box-shadow: rgba(0, 0, 0, 25%) 0 3px 3px 0;
}

.switch_switch__JeJO9.switch_inactive__5nHEx .switch_toggle__75E7X {
  transform: translate(-13px, 40px);
  box-shadow: rgba(0, 0, 0, 25%) 0 -3px 3px 0;
  background-color: #a9a9a9;
}

/* Nueva clase para cuando el switch está cargando */
.switch_switch__JeJO9.switch_loading__oPwkB {
  background-color: #d3d3d3;
  cursor: not-allowed;
  opacity: 0.5;
}

.switch_switch__JeJO9.switch_loading__oPwkB .switch_toggle__75E7X {
  background-color: #a9a9a9;
  box-shadow: none;
}

/* Spinner dentro del toggle */
.switch_spinner__R6dVi {
  border: 2px solid rgba(255, 255, 255, 0.3); /* Borde externo con opacidad */
  border-top: 2px solid white; /* Parte superior visible */
  border-radius: 50%;
  width: 15px;
  height: 15px;
  animation: switch_spin__XKJT2 1s linear infinite;
}

/* Animación del spinner */
@keyframes switch_spin__XKJT2 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/switch/switch.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;EACzB,eAAe;EACf,yDAAyD;EACzD,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,yBAAyB;EACzB,kBAAkB;EAClB,2DAA2D;EAC3D,0CAA0C;AAC5C;;AAEA;EACE,iCAAiC;EACjC,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA,oDAAoD;AACpD;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,0CAA0C,EAAE,+BAA+B;EAC3E,2BAA2B,EAAE,2BAA2B;EACxD,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gDAAkC;AACpC;;AAEA,0BAA0B;AAC1B;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  justify-content: end;\n  width: 100%;\n  border-radius: 6px;\n  margin: 0 30px 10px 30px;\n  position: relative;\n  align-items: center;\n}\n\n.switch {\n  width: 31px;\n  height: 71px;\n  position: relative;\n  display: inline-block;\n  padding: 8px;\n  margin-bottom: 5px;\n  border-radius: 200px;\n  background-color: #49546e;\n  cursor: pointer;\n  transition: background-color 0.3s ease, opacity 0.3s ease;\n  user-select: none;\n}\n\n.toggle {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  left: 16px;\n  top: 3px;\n  width: 25px;\n  height: 25px;\n  transform: translateX(-50%);\n  background-color: #88d36e;\n  border-radius: 50%;\n  transition: transform 0.3s ease, background-color 0.3s ease;\n  box-shadow: rgba(0, 0, 0, 25%) 0 3px 3px 0;\n}\n\n.switch.inactive .toggle {\n  transform: translate(-13px, 40px);\n  box-shadow: rgba(0, 0, 0, 25%) 0 -3px 3px 0;\n  background-color: #a9a9a9;\n}\n\n/* Nueva clase para cuando el switch está cargando */\n.switch.loading {\n  background-color: #d3d3d3;\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.switch.loading .toggle {\n  background-color: #a9a9a9;\n  box-shadow: none;\n}\n\n/* Spinner dentro del toggle */\n.spinner {\n  border: 2px solid rgba(255, 255, 255, 0.3); /* Borde externo con opacidad */\n  border-top: 2px solid white; /* Parte superior visible */\n  border-radius: 50%;\n  width: 15px;\n  height: 15px;\n  animation: spin 1s linear infinite;\n}\n\n/* Animación del spinner */\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `switch_container__p1G07`,
	"switch": `switch_switch__JeJO9`,
	"toggle": `switch_toggle__75E7X`,
	"inactive": `switch_inactive__5nHEx`,
	"loading": `switch_loading__oPwkB`,
	"spinner": `switch_spinner__R6dVi`,
	"spin": `switch_spin__XKJT2`
};
export default ___CSS_LOADER_EXPORT___;
